__turbopack_context__.v({
  "countLabel": "leagueTablePage-module-scss-module__Ahb1AG__countLabel",
  "leagueTableContainer": "leagueTablePage-module-scss-module__Ahb1AG__leagueTableContainer",
  "link": "leagueTablePage-module-scss-module__Ahb1AG__link",
  "mobileTabSelect": "leagueTablePage-module-scss-module__Ahb1AG__mobileTabSelect",
  "nameCell": "leagueTablePage-module-scss-module__Ahb1AG__nameCell",
  "row": "leagueTablePage-module-scss-module__Ahb1AG__row",
  "searchInput": "leagueTablePage-module-scss-module__Ahb1AG__searchInput",
  "searchInputField": "leagueTablePage-module-scss-module__Ahb1AG__searchInputField",
  "tableRow": "leagueTablePage-module-scss-module__Ahb1AG__tableRow",
  "topItemsEmptyMessage": "leagueTablePage-module-scss-module__Ahb1AG__topItemsEmptyMessage",
  "topItemsTable": "leagueTablePage-module-scss-module__Ahb1AG__topItemsTable",
  "topItemsTableContainer": "leagueTablePage-module-scss-module__Ahb1AG__topItemsTableContainer",
  "typeCell": "leagueTablePage-module-scss-module__Ahb1AG__typeCell",
});
